// src/services/notificationService.js
const API_BASE = 'https://core.agritechbanking.com/api/v1/users';

export const fetchNotifications = async (token) => {
  try {
    console.log(token)
    const response = await fetch(`${API_BASE}/notifications`,{headers: {
        'Content-Type': 'application/json',
        'Authorization':`Bearer ${token}`
      }});
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch notifications:', error);
    throw error;
  }
};

export const markNotificationAsRead = async (token) => {
  try {

    // Assuming your API endpoint for marking as read is something like:
    // PATCH /api/v1/users/notifications/{id}/read
    // You will need to adjust the URL and method based on your actual API.
    const response = await fetch(`${API_BASE}/notifications/seen`, {
      method: 'POST', // or 'POST', based on your API
      headers: {
        'Content-Type': 'application/json',
        'Authorization':`Bearer ${token}`
      },
    });
    console.log('markNotificationAsRead',response)
    if (!response.ok) {
      throw new Error(`Failed to mark notification as read. Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error marking notification as read:', error);
    throw error;
  }
};

export const markSelectedNotificationAsRead = async (id,token) => {
  try {

    // Assuming your API endpoint for marking as read is something like:
    // PATCH /api/v1/users/notifications/{id}/read https://core.agritechbanking.com/api/v1/users/notifications/$id/read
    // You will need to adjust the URL and method based on your actual API.
    const response = await fetch(`${API_BASE}/notifications/${id}/read`, {
      method: 'POST', // or 'POST', based on your API
      headers: {
        'Content-Type': 'application/json',
        'Authorization':`Bearer ${token}`
      },
    });
    console.log('markNotificationAsRead',response)
    if (!response.ok) {
      throw new Error(`Failed to mark notification as read. Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error marking notification as read:', error);
    throw error;
  }
};